var clamp = function (a, min, max) {
    if (a < min) {
        return min;
    }
    else if (a > max) {
        return max;
    }
    return a;
};
export default clamp;
//# sourceMappingURL=clamp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/clamp.js
// module id = 459
// module chunks = 3